import axios from "axios";
import ConnUrls from '../Connections/ConnectURL'


const goCardCom = async (theOrder) => {

    let dFromF = await axios.post(ConnUrls.ApiUrl + "goCardCom", theOrder);
    return (dFromF.data);
}



const cardChargeToken = async (theOrder) => {
    let dFromF = await axios.post(ConnUrls.ApiUrl + "goCardCom/chargeToken", theOrder);
    return (dFromF.data);
}



const CardComApprove = async (theOrder) => {

    let dFromF = await axios.post(ConnUrls.ApiUrl + "goCardCom/ApproveCardCom", theOrder);
    return (dFromF.data);
}
const createJ5Hold = async (theOrder) => {
    let dFromF = await axios.post(ConnUrls.ApiUrl + "goCardCom/createJ5Hold", theOrder);
    return (dFromF.data);
}

const chargeJ5 = async (theOrder) => {
    let dFromF = await axios.post(ConnUrls.ApiUrl + "goCardCom/chargeJ5", theOrder);
    return (dFromF.data);
}

export default {
    goCardCom,
    CardComApprove,
    cardChargeToken,
     createJ5Hold,
    chargeJ5   
};